<template>
  <header v-if="isAuthenticated" class="smile-header">
    <div class="smile-header-container smile-header-container-menu">
      <div class="smile-header-logo-page">
        <span class="smile-header-title">{{ headerTitle() }}</span>
      </div>
    </div>

    <div class="smile-header-logo">
      <router-link :to="{ path: '/' }" class="smile-header-logo-link">
        <img src="@/assets/images/smile-logo-header-one-line.svg" alt="SmileKiosk">
      </router-link>
    </div>

    <nav class="smile-header-nav-desktop">
      <router-link :to="{ path: '/' }">
        Αρχική
      </router-link>
      <router-link :to="{ path: '/loyalty-card' }">
        Κάρτα
      </router-link>
      <router-link :to="{ path: '/invoices' }" :class="exactActiveClass('invoices')">
        Ιστορικό Αγορών
      </router-link>
      <router-link :to="{ path: '/points' }" :class="exactActiveClass('points')">
        Σημεία
      </router-link>
      <router-link :to="{ path: '/account' }" :class="exactActiveClass('account')">
        Προφίλ
      </router-link>
    </nav>

    <router-link :to="{ path: '/loyalty-card' }" custom v-slot="{ navigate }"
    >
      <div class="smile-header-container smile-header-container-coins"
           @click="navigate" @keypress.enter="navigate" role="link">
        <span class="header-coins-text">
          <span class="header-coins-text-wrapper">
            <b>{{goldCoins}}</b>
            <span class="header-smiles-text">smiles</span>
          </span>
          <img src="@/assets/images/smile-coin-transparent.svg" alt="Smile Coin">
        </span>
      </div>
    </router-link>
  </header>

  <header v-else class="smile-header-login-page">
    <div class="smile-header-logo">
      <router-link :to="{ path: '/' }">
        <img src="@/assets/images/smile-logo-header-one-line-aunauthenticated.svg" alt="SmileKiosk">
      </router-link>
    </div>
  </header>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const userContext = createNamespacedHelpers('user');

export default {
  name: 'AppHeader',
  props: {
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...userContext.mapState({
      goldCoins: state => parseInt(state.goldCoins, 10),
    }),
  },
  data() {
    return {
      exactActiveClass: (linkPathName = '') => {
        if (this.$route.meta.linkPath === linkPathName) {
          return 'router-link-exact-active';
        }

        return '';
      },
      headerTitle: () => this.$route.meta.pageTitle,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .smile-header-login-page {
    width:100%;
    height:53px;
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px
  }

  .smile-header-login-page .smile-header-logo {
    text-align:center;
    width: fit-content;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue